// extracted by mini-css-extract-plugin
export default {"footer":"page-footer_footer__9Tus+","subDividerContent":"page-footer_subDividerContent__ldWA3","dividerSpacing":"page-footer_dividerSpacing__nxfec"};